import { render, staticRenderFns } from "./QueryContainer.vue?vue&type=template&id=04482387&scoped=true"
import script from "./QueryContainer.vue?vue&type=script&lang=js"
export * from "./QueryContainer.vue?vue&type=script&lang=js"
import style0 from "./QueryContainer.vue?vue&type=style&index=0&id=04482387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04482387",
  null
  
)

export default component.exports